import type { CustomerFieldMapping, CustomerMappableField } from "./payloadTypes";

/**
 * Fallback question metadata for critical hosted-step fields.
 *
 * CMS customerFieldMapping is the primary source (checked first at runtime).
 * These fallbacks activate ONLY when CMS data is missing — providing a safety
 * net against accidental CMS admin edits breaking critical customer detail mappings.
 *
 * Keyed by fieldKey (matches PayloadFormQuestion.fieldKey).
 */
export interface HostedStepFallback {
  fieldKey: string;
  customerField: CustomerMappableField;
  valueTransform: NonNullable<CustomerFieldMapping["valueTransform"]>;
}

export const HOSTED_STEP_FALLBACKS: Record<string, HostedStepFallback> = {
  IS_US_CITIZEN: { fieldKey: "IS_US_CITIZEN", customerField: "isUsCitizen", valueTransform: "boolean" },
  HAS_RN_LICENSE: { fieldKey: "HAS_RN_LICENSE", customerField: "hasRNLicense", valueTransform: "boolean" },
  HAS_MILITARY_AFFILIATION: { fieldKey: "HAS_MILITARY_AFFILIATION", customerField: "hasMilitaryAffiliation", valueTransform: "boolean" },
  GRAD_YEAR: { fieldKey: "GRAD_YEAR", customerField: "graduatedHighSchoolIn", valueTransform: "string" },
  DATE_OF_BIRTH: { fieldKey: "DATE_OF_BIRTH", customerField: "dob", valueTransform: "string" },
  EDUCATION_LEVEL: { fieldKey: "EDUCATION_LEVEL", customerField: "educationLevel", valueTransform: "string" },
  ADDRESS_ZIP_ONLY: { fieldKey: "ADDRESS_ZIP_ONLY", customerField: "address.zip", valueTransform: "string" },
};
